import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import zhTW from './locales/zh-TW.json'

Vue.use(VueI18n)

// Determine the default language
// const navLang = navigator.language || navigator.userLanguage
// const localLang = (navLang === 'zh-TW' || navLang === 'zh-HK') ? 'zh-TW' : 'en'
const lang = localStorage.getItem('lang') || 'zh-TW'

const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: 'zh-TW',
  messages: {
    'en': en,
    'zh-TW': zhTW
  }
})

export default i18n




// WEBPACK FOOTER //
// ./src/i18n/index.js